import * as am4core from "@amcharts/amcharts4/core";
import {am4Settings} from "@/mixins/am4charts/am4Settings";

export const am4SeriesMixin = {
    data() {
        return {

        }
    },
    methods: {

        // Setup Series Bullets
        am4SetupSeriesBullets(chart, series) {
            if (this._am4ChartInvalid(chart)) {
                return
            }
            // Add Bullets to series
            let bullets = series.bullets.push(new am4core.Circle())
            bullets.radius = 3

            bullets.adapter.add('disabled', param => {
                return chart.data.length === 0
            })
        },

        // Setup Series Grouping
        am4SetupSeriesGrouping(series, alarmValues, id) {
            // Let's add a custom aggregate function
            series.adapter.add("groupDataItem", val => {
                val[`${id}_tooltip`] = val.dataItem.dataContext.tooltip

                let min = 1000000
                let max = -1000000
                let mean = 0

                val.dataItem.groupDataItems.forEach(subVal => {
                    let v = subVal.valueY
                    min = Math.min(min, v)
                    max = Math.max(max, v)
                    mean += v
                })
                if (val.dataItem.groupDataItems.length > 0) {
                    mean /= val.dataItem.groupDataItems.length
                }
                let thisMax = max
                let thisMin = min

                if (thisMax > alarmValues.highAlarmValue){
                    val[id] = thisMax;
                } else if (thisMin < alarmValues.lowAlarmValue){
                    val[id] = thisMin;
                } else if (thisMax > alarmValues.highCautionValue){
                    val[id] = thisMax;
                } else if (thisMin < alarmValues.lowCautionValue){
                    val[id] = thisMin;
                } else {
                    val[id] = mean
                }

                return val;
            })
        },

        // Update Gap And Min Bullet Distance
        am4UpdateGapAndMinBulletDistance(chart, dateAxis, useShortGaps, isHeavyLoad, hasMultiplePoints) {
            if (this._am4ChartInvalid(chart)) {
                return
            }

            // The gaps are assumed to be minutes.  We need to increase or decrease their time based on the data's baseInterval
            let scrollSeries = chart.scrollbarX
            if (!_.isNil(scrollSeries !== null) &&
                    !_.isNil(scrollSeries.scrollbarChart) &&
                    scrollSeries.scrollbarChart.series.length > 0) {
                scrollSeries = scrollSeries.scrollbarChart.series.getIndex(0)
            }

            let series = chart.series.getIndex(0)

            let multiplier = 1
            let interval = dateAxis.baseInterval.timeUnit
            if (interval === 'second') {
                multiplier = 60
            }
            else if (interval === 'hour') {
                multiplier = 1.0 / 60
            }
            else if (interval === 'day') {
                multiplier = 1.0 / 60 / 24
            }

            let gapCount = useShortGaps ? am4Settings.SHORT_GAP_LENGTH * multiplier : am4Settings.LONG_GAP_LENGTH * multiplier
            series.minBulletDistance = am4Settings.MIN_BULLET_DISTANCE
            series.autoGapCount = gapCount

            if (!isHeavyLoad && !_.isNil(scrollSeries)) {
                scrollSeries.minBulletDistance = 1000
                scrollSeries.autoGapCount = gapCount
            }

            if (chart.series.length > 1) {
                let seriesB = chart.series.getIndex(1)
                seriesB.minBulletDistance = am4Settings.MIN_BULLET_DISTANCE
                seriesB.autoGapCount = gapCount
            }

        },

        am4SeriesResetBullets(chart, series = null) {
            // If we get a specific series perform the bullet reset for that series & bail.
            if (!_.isNil(series)) {
                series.bullets.clear()
                this.am4SetupSeriesBullets(chart, series)
                return
            }

            // Otherwise perform the bullet reset on every series on the chart
            this.chart.series.each((item, index) => {
                item.bullets.clear()
                this.am4SetupSeriesBullets(this.chart, item)
            })
        },

        // Ensure that a chart is valid
        _am4ChartInvalid(chart) {
            return _.isNil(chart)
        }
    },
}